import React                       from 'react';
import {
  cooperInner as defaultInnerOptions,
  cooperOuter as defaultOuterOptions,
}                                  from 'pu-data/SelectOptions';
import {
  copperWeight as tooltip,
  copperInner as tooltipInner,
  copperOuter as tooltipOuter,
} from 'pu-data/Tooltips';
import SelectDualComponent         from './SelectDualComponent';

const CopperWeightInline = props => (
  <SelectDualComponent
    {...props}
    defaultOptionsA={props.innerOptions}
    defaultOptionsB={props.outerOptions}
    label={props.label}
    labelBottomA={props.labelBottomInner}
    labelBottomB={props.labelBottomOuters}
    nameA="copper_inners"
    nameB="copper_outers"
    required={props.required}
    tooltip={props.tooltip} />
);

const CopperWeightTwoCols = props => (
  <SelectDualComponent
    {...props}
    label={false}
    tooltip={false}
    defaultOptionsA={props.innerOptions}
    defaultOptionsB={props.outerOptions}
    labelTopA={props.labelInner}
    labelTopB={props.labelOuters}
    nameA="copper_inners"
    nameB="copper_outers"
    requiredA={props.requiredInner}
    requiredB={props.requiredOuters}
    tooltipA={props.tooltipInner}
    tooltipB={props.tooltipOuter} />
);

const CopperWeight = (props) => {
  if (props.template === 'inline') {
    return <CopperWeightInline {...props} />
  }

  return <CopperWeightTwoCols {...props} />
}

const CopperWeight2 = props => (
  <SelectDualComponent
    {...props}
    defaultOptionsA={props.innerOptions}
    defaultOptionsB={props.outerOptions}
    label={props.label}
    labelTopA={props.labelInner}
    labelTopB={props.labelOuters}
    labelBottomA={props.labelBottomInner}
    labelBottomB={props.labelBottomOuters}
    nameA="copper_inners"
    nameB="copper_outers"
    required={props.required}
    requiredA={props.requiredInner}
    requiredB={props.requiredOuters}
    tooltip={props.tooltip}
    tooltipA={props.tooltipInner}
    tooltipB={props.tooltipOuter} />
);

CopperWeight.defaultProps = {
  label            : 'Copper Weight',
  labelInner       : 'Inner<br class="d-none d-lg-block d-xl-none" /> Copper Wt.',
  labelOuters      : 'Outer<br class="d-none d-lg-block d-xl-none" /> Copper Wt.',
  labelBottomInner : 'Inner',
  labelBottomOuters: 'Outer',
  requiredInner    : false,
  requiredOuters   : false,
  innerOptions     : defaultInnerOptions,
  outerOptions     : defaultOuterOptions,
  tooltip,
  tooltipInner,
  tooltipOuter,
  template         : 'inline',
};

export default CopperWeight;
